var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMessageRecivedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_message",
    "data-name": "new message",
    transform: "translate(-1284 -591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528",
    transform: "translate(1284.476 591.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    d: "M9,0h9a9,9,0,0,1,9,9V26a1,1,0,0,1-1,1H9a9,9,0,0,1-9-9V9A9,9,0,0,1,9,0Z",
    transform: "translate(-0.476 -0.476)",
    fill: "#1738f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5368",
    "data-name": "Group 5368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Type_indicator",
    "data-name": "Type indicator",
    transform: "translate(1241.819 548.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M49.457,60.261a.835.835,0,0,0-.146-.549,1.573,1.573,0,0,0-.094-.14A7.379,7.379,0,0,1,48,55.51a7.7,7.7,0,0,1,15.2-1.532,7.348,7.348,0,0,1,.164,1.538,7.531,7.531,0,0,1-7.556,7.568,9.041,9.041,0,0,1-2.086-.309c-.5-.139-.994-.324-1.122-.373a1.15,1.15,0,0,0-.411-.076,1.134,1.134,0,0,0-.446.09l-2.505.9a.588.588,0,0,1-.172.045A.355.355,0,0,1,48.71,63a.586.586,0,0,1,.022-.122Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1299 595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M1.178.97h.711V-2.8H1.227c0,.382-.226.566-.943.566V-1.7h.894Z",
    transform: "translate(1301.752 599.915)",
    fill: "#1738f3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessageRecivedIcon);
export default __webpack_public_path__ + "static/media/new-message-recived-icon.67822a583b6e91ec6618a35b130692df.svg";
export { ForwardRef as ReactComponent };